import React, { useState } from "react"
import ViewButton from "images/inline/gallery/view-button.svg"
import PlayButton from "images/inline/gallery/play-button.svg"
import Image from "./Image"

import "./GalleryItem.scss"

const getMediaType = (uploadFile) => {
  let mediaType = "photo"
  let videoArray = ["mov", "mp4", "avi", "MOV", "MP4", "AVI"]
  if (videoArray.includes(uploadFile.split(".").pop())) {
    mediaType = "video"
  }
  return mediaType
}


const GalleryItem = ({ item, id, title, caption, name, thumbnail, uploadFile, votes = 0, image = null, video = null, handleItemClick = function (id) {}, onVoteClick = () => {}, zeroVotesCopy="", galleryWidth }) => {
  const [voteCount, setVoteCount] = useState(votes)


  let mediaType = getMediaType(uploadFile)

  const handleVoteClick = itemId => {
    onVoteClick(itemId)
    setVoteCount(voteCount + 1)
  }

  return (
    <div className={`gallery-item ${mediaType ? `media-type-${mediaType}` : ""}`} style={{"--flex-basis": `${100 / galleryWidth}%`}}>
      <div className="gallery-item__inside">
        <div className="gallery-item__image-area">
          <a
            className="gallery-item__image-area-clickable-zone"
            role="button"
            onClick={() => {
              handleItemClick(id)
            }}>
            <div className="gallery-item__image-icon">
              <ViewButton />
            </div>
            <div className="gallery-item__background-container">
              {thumbnail && <Image src={`${process.env.SITE_ASSET_URL}/${thumbnail}`} />}

              {mediaType === "video" && (
                <div className="gallery-item__video-button">
                  <PlayButton />
                </div>
              )}
            </div>

            <div className="gallery-item__submitter">{name && `Submitted by ${name}`}</div>
          </a>
        </div>
        <div className="gallery-item__bottom-area">
          <div className="gallery-item__votes">{votes === 0 ? zeroVotesCopy : `${votes} Votes`}</div>

          <div className="gallery-item__vote-button">
            {" "}
            <button
              className={`btn ${!item.userVotedToday ? 'themed-button' : 'themed-secondary'}`}
              disabled={!item.userVotedToday ? false : true}
              onClick={() => {
                handleVoteClick(id)
              }}>
              {!item.userVotedToday ? `Vote` : (galleryWidth < 5 ? `Your Vote is In`: `Voted`)}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
export default GalleryItem
